var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "page-tournaments__list",
      class: [_vm.reference + "-tournament", { load: _vm.load }]
    },
    [
      !_vm.isMobile || (_vm.isMobile && _vm.active === _vm.reference)
        ? _c("div", { staticClass: "page-tournaments__list-title" }, [
            _c("h3", [_vm._v(_vm._s(_vm.mainTitle))]),
            _c("div", { staticClass: "line" })
          ])
        : _vm._e(),
      (!_vm.isMobile || (_vm.isMobile && _vm.active === _vm.reference)) &&
      !_vm.items.length
        ? _c("div", { staticClass: "page-tournaments__list-empty" }, [
            _c("h3", [_vm._v(_vm._s(_vm.emptyTitle))]),
            _c("div"),
            _c("p", [
              _vm._v(_vm._s(_vm.$t("front.tournament.empty.description")))
            ])
          ])
        : _vm._e(),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isMobile && _vm.active === _vm.reference,
              expression: "isMobile && active === reference"
            }
          ],
          staticClass: "page-tournaments__swiper-items"
        },
        [
          _c(
            "swiper",
            { ref: "tournaments", attrs: { options: _vm.settings } },
            _vm._l(_vm.items, function(item, index) {
              return _c("swiper-slide", { key: index, staticClass: "item" }, [
                _c(
                  "div",
                  {
                    staticClass: "item__image",
                    class: _vm.reference,
                    style:
                      "background-image: linear-gradient(black, black), url(" +
                      _vm.tournamentBackground(item) +
                      ")"
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: _vm.tournamentImage(item),
                        alt: _vm.tournamentTitle(item)
                      }
                    }),
                    item.type.toLowerCase() === "private"
                      ? _c("div", { staticClass: "badge private" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("front.tournament.title.private")) +
                              "\n                    "
                          )
                        ])
                      : _vm._e()
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "item__content" },
                  [
                    _c("div", {
                      staticClass: "info",
                      on: {
                        click: function($event) {
                          return _vm.open(item.games)
                        }
                      }
                    }),
                    _c("div", { staticClass: "badge", class: item.status }, [
                      _vm._v(
                        _vm._s(_vm.$t("front.tournament.status." + item.status))
                      )
                    ]),
                    _c("div", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.tournamentTitle(item)))
                    ]),
                    _c("div", { staticClass: "date" }, [
                      _c("div", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.dateTitle))
                      ]),
                      _vm.checkDate
                        ? _c(
                            "div",
                            { staticClass: "value" },
                            [
                              _c("countdown-timer", {
                                attrs: { date: _vm.tournamentDate(item) }
                              })
                            ],
                            1
                          )
                        : _c("div", { staticClass: "value" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.formattedDate(item.endDate)) +
                                "\n                        "
                            )
                          ])
                    ]),
                    _vm.award(item, 1)
                      ? _c("div", { staticClass: "prize" }, [
                          _c("div", { staticClass: "title" }, [
                            _vm._v(
                              _vm._s(_vm.$t("front.tournament.title.award"))
                            )
                          ]),
                          _c("div", { staticClass: "value" }, [
                            _c("i", { staticClass: "icon" }),
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.award(item, 1)) +
                                "\n                        "
                            )
                          ])
                        ])
                      : _vm._e(),
                    _c(
                      "v-btn",
                      {
                        on: {
                          click: function($event) {
                            return _vm.tournamentUrl(item)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.buttonLabel(item)) +
                            "\n                    "
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            }),
            1
          ),
          _c(
            "div",
            { staticClass: "swiper-navigation" },
            [
              _c(
                "v-btn",
                { staticClass: "prev", on: { click: _vm.slidePrev } },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "11",
                        height: "10",
                        viewBox: "0 0 11 10",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M6 1L2 5L6 9",
                          stroke: "white",
                          "stroke-width": "1.5"
                        }
                      }),
                      _c("path", {
                        attrs: {
                          d: "M2.5 5H10.5",
                          stroke: "white",
                          "stroke-width": "1.5"
                        }
                      })
                    ]
                  )
                ]
              ),
              _c(
                "div",
                { staticClass: "pagination" },
                _vm._l(_vm.items.length, function(index) {
                  return _c("span", {
                    key: index,
                    class: { active: _vm.activeSlide === index - 1 },
                    on: {
                      click: function($event) {
                        return _vm.slideTo(index)
                      }
                    }
                  })
                }),
                0
              ),
              _c(
                "v-btn",
                { staticClass: "next", on: { click: _vm.slideNext } },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "11",
                        height: "10",
                        viewBox: "0 0 11 10",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M5 1L9 5L5 9",
                          stroke: "white",
                          "stroke-width": "1.5"
                        }
                      }),
                      _c("path", {
                        attrs: {
                          d: "M8.5 5H0.5",
                          stroke: "white",
                          "stroke-width": "1.5"
                        }
                      })
                    ]
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isMobile,
              expression: "!isMobile"
            }
          ],
          staticClass: "page-tournaments__list-items"
        },
        _vm._l(_vm.items, function(item, index) {
          return _c(
            "div",
            {
              key: index,
              ref: _vm.reference,
              refInFor: true,
              staticClass: "item"
            },
            [
              _c(
                "div",
                {
                  staticClass: "item__image",
                  class: _vm.reference,
                  style:
                    "background-image: " +
                    (_vm.reference === "finished"
                      ? "linear-gradient(black, black),"
                      : "") +
                    " url(" +
                    _vm.tournamentBackground(item) +
                    ")"
                },
                [
                  _c("img", {
                    attrs: {
                      src: _vm.tournamentImage(item),
                      alt: _vm.tournamentTitle(item)
                    }
                  }),
                  item.type.toLowerCase() === "private"
                    ? _c("div", { staticClass: "badge private" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("front.tournament.title.private")) +
                            "\n                "
                        )
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "info" }, [
                    _c("div", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("front.tournament.title.length")) +
                          "\n                        "
                      ),
                      _c("strong", [_vm._v(_vm._s(_vm.tournamentLength(item)))])
                    ]),
                    item.spinLimit
                      ? _c("div", [
                          _c("span", [_vm._v("|")]),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("front.tournament.title.spins")) +
                              "\n                        "
                          ),
                          _c("strong", [
                            _vm._v(_vm._s(parseInt(item.spinLimit)))
                          ])
                        ])
                      : _vm._e(),
                    item.minBetAmount
                      ? _c("div", [
                          _c("span", [_vm._v("|")]),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("front.tournament.title.min_bet")) +
                              "\n                        "
                          ),
                          _c("strong", [
                            _vm._v(
                              _vm._s(item.minBetAmount) +
                                " " +
                                _vm._s(item.currency)
                            )
                          ])
                        ])
                      : _vm._e()
                  ])
                ]
              ),
              _c(
                "div",
                { staticClass: "item__content" },
                [
                  _c("div", {
                    staticClass: "info",
                    on: {
                      click: function($event) {
                        return _vm.open(item.games)
                      }
                    }
                  }),
                  _c("div", { staticClass: "badge", class: item.status }, [
                    _vm._v(
                      _vm._s(_vm.$t("front.tournament.status." + item.status))
                    )
                  ]),
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.tournamentTitle(item)))
                  ]),
                  _c("div", { staticClass: "date" }, [
                    _c("div", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.dateTitle))
                    ]),
                    _vm.checkDate
                      ? _c(
                          "div",
                          { staticClass: "value" },
                          [
                            _c("countdown-timer", {
                              attrs: { date: _vm.tournamentDate(item) }
                            })
                          ],
                          1
                        )
                      : _c("div", { staticClass: "value" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.formattedDate(item.endDate)) +
                              "\n                    "
                          )
                        ])
                  ]),
                  _vm.award(item, 1)
                    ? _c("div", { staticClass: "prize" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v(_vm._s(_vm.$t("front.tournament.title.award")))
                        ]),
                        _c("div", { staticClass: "value" }, [
                          _c("i", { staticClass: "icon" }),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.award(item, 1)) +
                              "\n                    "
                          )
                        ])
                      ])
                    : _vm._e(),
                  _c(
                    "v-btn",
                    {
                      on: {
                        click: function($event) {
                          return _vm.tournamentUrl(item)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.buttonLabel(item)) +
                          "\n                "
                      )
                    ]
                  )
                ],
                1
              )
            ]
          )
        }),
        0
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: _vm.isDialogPersistent,
            "max-width": "600",
            scrollable: ""
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c("tournament-related-games", {
            attrs: { "related-games": _vm.dialogItem },
            on: { close: _vm.close }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }